import useQuery from '_hooks/useQuery'

export const useShareInitialParams = () => {
  const params = useQuery()

  const eid = params.get('eid') || params.get('bid')
  const oid = params.get('oid')
  const shareCode = params.get('shareCode')
  const sharedId = params.get('sharedId')
  const isEventShop = params.get('eventShop')

  return {
    eid,
    oid,
    shareCode,
    sharedId,
    isEventShop,
  }
}

export default useShareInitialParams
